import React from 'react';
import { graphql } from 'gatsby';
import Layout from 'components/Layout';
import SEO from 'components/SEO';
import Hero from 'components/Hero';
import AudienceComparison from 'components/_page/pricing/AudienceComparison';
import Tout from 'components/Tout';
import FeatureComparison from 'components/_page/pricing/FeatureComparison';

export default ({ data }) => {
  const pricing = data.prismic.allPricings.edges[0].node;

  return (
    <Layout>
      <SEO
        title={pricing.social_title || 'Pricing'}
        description={pricing.social_description ? pricing.social_description : null}
        image={pricing.social_image ? pricing.social_image.url : null}
      />

      <Hero
        rubric={pricing.hero_intro}
        heading={pricing.hero_heading}
        content={pricing.hero_content}
      />

      <AudienceComparison
        rubric={pricing.audience_comparison_intro}
        facts={pricing.pricing_facts}
        products={pricing.products}
      />

      {(pricing.tout_heading || pricing.tout_content) && (
        <Tout
          heading={pricing.tout_heading}
          content={pricing.tout_content}
          buttonText={pricing.tout_button_text}
          destination={pricing.tout_button_destination}
        />
      )}

      {pricing.body && (
        <FeatureComparison
          featureGroups={pricing.body}
          products={pricing.products}
        />
      )}
    </Layout>
  );
};

export const query = graphql`
    {
        prismic {
            allPricings {
                edges {
                    node {
                        hero_intro
                        hero_content
                        hero_heading
                        audience_comparison_intro
                        pricing_facts {
                            heading
                            text
                        }
                        products {
                            product {
                                ... on PRISMIC_Product {
                                    logo
                                    name
                                    audience_traits {
                                        text
                                    }
                                    preview_image
                                    logline
                                    comparison_features {
                                        feature {
                                            ... on PRISMIC_Feature {
                                                name
                                                tooltip
                                            }
                                        }
                                    }
                                }
                            }
                            cta_destination
                        }
                        tout_heading
                        tout_content
                        tout_button_text
                        tout_button_destination
                        body {
                            ... on PRISMIC_PricingBodyFeature_group {
                                primary {
                                    heading
                                }
                                fields {
                                    feature {
                                        ... on PRISMIC_Feature {
                                            name
                                            tooltip
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;
